module.exports = __webpack_public_path__ + "static/media/video_2_imagem.ce171e74.png";